import { c as _c } from "react/compiler-runtime";
import type { VaultKind } from '@onefootprint/request-types';
import type { GraphOperationResult } from '@onefootprint/request-types/dashboard';
import { motion } from 'framer-motion';
import { Suspense, useState } from 'react';
import useSidebar from '@/components/playbook-builder/hooks/use-sidebar';
import useDirty from '../../../hooks/use-dirty';
import useNodeContext from '../../../hooks/use-node-context';
import useStore from '../../../hooks/use-store';
import AddButton from '../../add-button';
import AddNodeDialog from '../../add-node-dialog';
import type { ApplyEditMutation } from '../base-node';
type AddBeforeNodeProps = {
  nodeId: string;
  mutation: ApplyEditMutation;
  subject: VaultKind;
};
const AddBeforeNode = t0 => {
  const $ = _c(19);
  const {
    nodeId,
    mutation,
    subject
  } = t0;
  const {
    addBeforeNodeOperations
  } = useNodeContext(nodeId);
  const {
    isAnyComponentDirty
  } = useDirty();
  const {
    data: t1
  } = useStore();
  const {
    graph
  } = t1;
  const {
    onOperationComplete
  } = useSidebar();
  const [open, setOpen] = useState(false);
  let t2;
  if ($[0] !== isAnyComponentDirty || $[1] !== mutation.isPending) {
    t2 = () => {
      if (mutation.isPending || isAnyComponentDirty) {
        return;
      }
      setOpen(true);
    };
    $[0] = isAnyComponentDirty;
    $[1] = mutation.isPending;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const handleClick = t2;
  let t3;
  if ($[3] !== onOperationComplete) {
    t3 = operation => {
      setOpen(false);
      onOperationComplete(operation);
    };
    $[3] = onOperationComplete;
    $[4] = t3;
  } else {
    t3 = $[4];
  }
  const handleClose = t3;
  const currentNode = graph.nodes.find(node => node.id === nodeId);
  const isPlaceholderNode = currentNode?.kind === "placeholder";
  if (!addBeforeNodeOperations.length || isPlaceholderNode) {
    return null;
  }
  let t4;
  let t5;
  let t6;
  let t7;
  if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = {
      opacity: 0
    };
    t5 = {
      opacity: 0
    };
    t6 = {
      opacity: 1
    };
    t7 = {
      duration: 0.2
    };
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
    $[8] = t7;
  } else {
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
    t7 = $[8];
  }
  let t8;
  if ($[9] !== handleClick) {
    t8 = <AddButton onClick={handleClick} />;
    $[9] = handleClick;
    $[10] = t8;
  } else {
    t8 = $[10];
  }
  let t9;
  if ($[11] !== addBeforeNodeOperations || $[12] !== handleClose || $[13] !== open || $[14] !== subject) {
    t9 = <Suspense fallback={null}><AddNodeDialog open={open} onClose={handleClose} operations={addBeforeNodeOperations} subject={subject} /></Suspense>;
    $[11] = addBeforeNodeOperations;
    $[12] = handleClose;
    $[13] = open;
    $[14] = subject;
    $[15] = t9;
  } else {
    t9 = $[15];
  }
  let t10;
  if ($[16] !== t8 || $[17] !== t9) {
    t10 = <motion.div className="flex absolute right-0 left-0 -top-9 justify-center pointer-events-auto" initial={t4} animate={t5} whileHover={t6} transition={t7}>{t8}{t9}</motion.div>;
    $[16] = t8;
    $[17] = t9;
    $[18] = t10;
  } else {
    t10 = $[18];
  }
  return t10;
};
export default AddBeforeNode;